import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-500 text-2xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-950">
                  51大赛
                </span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                深度吃瓜爱好者聚集地，聚焦网红明星塌房现场、博主反差猛料及私密聊天记录流出。每日更新独家黑料，追踪每日大赛。
              </p>
            </div>

            <div className="lg:w-1/4">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/about" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer">关于我们</Link></li>
                <li><a href="#hot-topics" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer">热门话题</a></li>
                <li><a href="#daily-competition" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer">每日大赛</a></li>
              </ul>
            </div>

            <div className="lg:w-1/4">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">吃瓜分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to="/"
                      className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:w-1/4">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-foreground-600 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-foreground-400 text-sm"></i>
                  </div>
                  hello@ahljjx.cn
                </li>
                <li className="flex items-center gap-2 text-foreground-600 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-wechat-line text-foreground-400 text-sm"></i>
                  </div>
                  51dasai_offical
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-400 text-xs">
              &copy; 2024 - 2026 51大赛吃瓜黑料网 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">隐私政策</a>
              <span className="text-foreground-300 text-xs">|</span>
              <a href="#" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">用户协议</a>
              <span className="text-foreground-300 text-xs">|</span>
              <a href="#" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}